module.exports = __webpack_public_path__ + "img/call.d4b3ca58.png";